import React from 'react'
import Testimonials from 'js/components/Testimonials/Testimonials'
import convert from 'htmr'

const transform = {
  strong: function Bold(props) {
    return <b className="font-bold">{props.children}</b>
  },
  p: function Paragraph(props) {
    return props.children
  },
}

type Props = {
  testimonials: {
    name: string
    age: number
    heading: string
    quote: string
    image: {
      responsiveImage: {
        src: string
        srcSet: string
      }
    }
  }[]
}

export default function TestimonialsBlock({ testimonials }: Props) {
  const mappedTestimonials = testimonials.map((item) => {
    var quotee = item.name
    if (item.age > 0) {
      quotee += ', ' + item.age
    }

    return {
      heading: convert(item.heading, { transform }),
      quote: convert(item.quote, { transform }),
      quotee: quotee,
      image: item.image.responsiveImage,
    }
  })

  return <Testimonials testimonials={mappedTestimonials} />
}
